<template>
  <div>
    <TitleContainer :title="'退会'"/>
    <div class="profile-info-block">
      <div class="profile-info">
        <!-- <p style="color: #787878">確認事項</p> -->
        <p>
          退会すると企業へのキャリア登録は解除され、運営事務局からの連絡も今後入ることはありません。
          また、マイページへのログインはできなくなり、サービス利用には再度の新規登録が必要です。
        </p>
        <div class="unsubscribe-button">
          <button class="btn btn-secondary rounded unsubscribe" @click="acceptUnsubscribe"
            >退会する</button
          >
        </div>
      </div>
    </div>
    <b-modal
      ref="unsubscribeModal"
      hide-header
      hide-footer
      centered
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      size="md"
    >
      <div class="logo text-center">
          <img class="img-logo" src="../assets/Group300.png"/>
      </div>
      <div class="swal-title text-center" style="color:#000;border-bottom: 1px solid #000;text-align: center;">
          退会が完了しました
      </div>

      <div class="swal-content text-center" style="border-bottom: 0px;">
        <button @click.prevent="handleCareerSuccess" class="swal-button swal-button--confirm" style="font-size: 16px;font-weight: 400;background-color: #FF0000; color: white; margin-bottom: 15px;padding: 10px 20px;">Bloomキャリア登録で転職が決まった方</button>
        <p class="swal-text m-0 text-center" style="font-weight: 400;color: #000000">謝礼付きのアンケートをお願いしています</p>
      </div>
      <div class="swal-footer text-center">
        <p style="font-size: 16px;cursor: pointer" @click.prevent="closeModal">
          ✕ 閉じる
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Api from '@/config/api';
// eslint-disable-next-line
import swal from "sweetalert";
import logo from '../assets/Group300.png';
import TitleContainer from './TitleContainer.vue';

export default {
  components: {
    TitleContainer
  },
  methods: {
    async acceptUnsubscribe() {
      swal({
        title: '	本当に退会しますか？',
        text: '退会すると企業へのキャリア登録は解除され、当社からの連絡も今後入ることはありません。\n また、マイページへのログインはできなくなり、サービス利用には再度の登録が必要になります。',
        icon: 'warning',
        className: 'custom-swal',
        buttons: {
          cancel: 'キャンセル',
          ok: {
            text: '退会する',
            value: true,
            visible: true,
            closeModal: false,
            className: 'custom-red',
          },
        },
      }).then(async (ok) => {
        if (ok) {
          try {
            await this.$auth.getToken();
            const response = await this.axios({
              method: 'delete',
              url: Api.url(Api.endpoints.deleteProfile),
            });
            swal.close();
            this.$refs.unsubscribeModal.show();
            // const content = document.createElement('div');
            // content.innerHTML = `
            //     <button id="career-success-btn" class="swal-button swal-button--confirm" style="background-color: #FF0000; color: white; margin-bottom: 15px;">Bloomキャリア登録で転職が決まった方</button>
            //     <p class="swal-text m-0 w-75 text-center" style="font-weight: 600;">謝礼付きのアンケートをお願いしています</p>
            //   `;            

            // const res = await swal({
            //   title: '退会が完了しました',
            //   content,
            //   icon: logo,
            //   className: 'custom-swal3',
            //   closeOnClickOutside: true,
            //   closeOnEsc: false,
            //   buttons: {
            //     cancel: {
            //       text: '✕ 閉じる',
            //       value: false,
            //       visible: true,
            //       className: 'swal-button swal-button--cancel',
            //       closeModal: true,
            //     },
            //   },
            // });

            // if (res) {
            //   window.open('https://forms.gle/qdHsexvPJesPgwLT9');
            //   swal.close();
            //   this.$router.push({ name: 'Logout' });
            // } else {
            //   swal.close();
            //   this.$router.push({ name: 'Logout' });
            // }
          } catch (error) {
            console.log(error);
            if (error.response.status == 503) {
              this.$router.push({ name: 'Logout' });
            }

            // this.$router.push({ name: "Logout" });
          }
        }
      });
      // if (
      //   confirm("「Bloomキャリア登録」にご登録済みの情報を全て削除しますか？")
      // ) {

      // }
    },
    handleCareerSuccess() {
      window.open('https://forms.gle/RzRzxFLxmVdMHgTP8');
      this.closeModal();
    },
    closeModal() {
      this.$refs.unsubscribeModal.hide();
      this.$router.push({ name: 'Logout'});
    }
  },
};
</script>

<style scoped>
p {
  color: #000000;
}
.unsubscribe {
  width: 120px;
  height: 43px;
  padding: 10px;
  background-color: #F9FAFB;
  color: #000000; 
  cursor:pointer
}

.unsubscribe:hover {
  background-color: #F9FAFB !important;
  opacity: 0.8;
  color: #000000;
}


@media (max-width: 767px) {
  .unsubscribe {
    width: 233px;
  }
  .unsubscribe-button {
    text-align: center;
  }
}

</style>
